export default "__VITE_PUBLIC_ASSET__6f03c596__"